import classNames from 'classnames';
import { Breadcrumb } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
export interface PageBreadcrumbItem {
  label: string;
  url?: string;
  active?: boolean;
}

interface PageBreadcrumbProps {
  items: PageBreadcrumbItem[];
  className?: string;
}

const PageBreadcrumb = ({ items, className }: PageBreadcrumbProps) => {

  const navigate = useNavigate();

  return (
    <Breadcrumb className={classNames(className, 'mb-2')}>
      {items.map(item => (
        <Breadcrumb.Item onClick={() => navigate(item.url ?? '')} active={item.active} key={item.label}>
          {item.label}
        </Breadcrumb.Item>
      ))
      }
    </Breadcrumb >
  );
};

export default PageBreadcrumb;
